import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import { Stack, TableRow, TableCell, Typography, IconButton } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import Iconify from 'src/components/iconify/Iconify';

import DepartmentDetails from 'src/sections/department/modal/DepartmentDetailsModal';

import DataCell from './DataCell';

DepartmentRow.propTypes = {
  row: PropTypes.object,
  handleOpenMenu: PropTypes.func,
  setSelected: PropTypes.func,
  getDeptTicketCount: PropTypes.func,
  getDeptUserCount: PropTypes.func,
  onManageMembers: PropTypes.func,
  showOptions: PropTypes.bool,
  canUpdate: PropTypes.bool,
};

export default function DepartmentRow({
  row,
  handleOpenMenu,
  setSelected,
  getDeptTicketCount,
  getDeptUserCount,
  onManageMembers,
  showOptions,
  canUpdate,
}) {
  const { isSmallScreen } = useResponsiveScreen();
  const { id, name, description } = row;
  const [openDepartmentDetails, setOpenDepartmentDetails] = useState(false);

  const [ticketCount, setTicketCount] = useState(0);
  const [userCount, setUserCount] = useState(0);

  useEffect(() => {
    getDeptUserCount(id, (res) => {
      setUserCount(res || 0);
    });

    getDeptTicketCount(id, (res) => {
      setTicketCount(res || 0);
    });
  }, [id, getDeptUserCount, getDeptTicketCount]);

  return (
    <>
      <DepartmentDetails
        open={openDepartmentDetails}
        setOpen={setOpenDepartmentDetails}
        department={row}
        tickets={ticketCount}
        users={userCount}
      />
      <TableRow
        hover
        sx={{ cursor: canUpdate ? 'pointer' : 'default' }}
        onClick={canUpdate ? () => onManageMembers(row) : undefined}
      >
        <TableCell component="th" scope="row">
          <Stack alignItems="center">
            <Typography
              variant="body2"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontSize: isSmallScreen && '0.65rem',
              }}
            >
              {id}
            </Typography>
          </Stack>
        </TableCell>
        <DataCell value={name} />
        <DataCell value={description} />
        <DataCell value={userCount} />
        <DataCell value={ticketCount} />

        {showOptions && (
          <TableCell
            align="center"
            sx={{
              position: 'sticky',
              zIndex: '100',
              right: 0,
              backgroundColor: 'background.paper',
            }}
          >
            <IconButton
              size={isSmallScreen ? 'small' : 'large'}
              color="inherit"
              onClick={(event) => {
                event.stopPropagation();
                handleOpenMenu(event, row);
                setSelected(row);
              }}
            >
              <Iconify
                icon="eva:more-vertical-fill"
                sx={{
                  width: 20,
                  height: isSmallScreen ? 16 : 20,
                }}
              />
            </IconButton>
          </TableCell>
        )}
      </TableRow>
    </>
  );
}
